import React, { useState } from "react";
import { Button, FlexContainer, StandardModal, StandardModalActionGroup } from "src/components";
import Copy from "src/img/copy.svg";
import { TextLabel } from "./style";

export default function SettingsDNS(props) {
    const { sendFromEmail, replyToEmail, settings, setShowDns } = props;

    const [lastRecordIndexCopied, setLastRecordIndexCopied] = useState(null);
    const [lastCopyWasHost, setLastCopyWasHost] = useState(true);

    const domainParts = (sendFromEmail || replyToEmail)?.split("@");
    const domain = domainParts && domainParts.length > 1 ? domainParts[1] : null;

    const copyValue = (value, index, isHost) => {
        navigator.clipboard.writeText(value);
        setLastRecordIndexCopied(index);
        setLastCopyWasHost(isHost);
    };

    return (
        <StandardModal
            open={true}
            onClose={() => setShowDns(false)}
            widthMode="table"
            title={`Authenticate ${domain ?? ""} Domain`}
            description="Copy and paste this info to the DNS settings on your domain provider's site."
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        type="button"
                        height="38px"
                        width="112px"
                        border="1px solid #000"
                        color="#000000"
                        onClick={() => setShowDns(false)}
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Close
                    </Button>
                </StandardModalActionGroup>
            )}
        >
            <FlexContainer width="100%">
                <FlexContainer
                    direction="row"
                    justifyContent="space-evenly"
                    gap="10px"
                    marginRight="20px"
                >
                    <FlexContainer width="20%"></FlexContainer>
                    <FlexContainer width="100%">
                        <TextLabel fontSize="16px" fontWeight="300" color="#CCCCCC">
                            HOST
                        </TextLabel>
                    </FlexContainer>
                    <FlexContainer width="100%">
                        <TextLabel fontSize="16px" fontWeight="300" color="#CCCCCC">
                            POINTS TO
                        </TextLabel>
                    </FlexContainer>
                </FlexContainer>
                <FlexContainer
                    style={{ borderBottom: "1px solid #D8DEEC" }}
                    padding="0px 0px 20px 0px"
                >
                    {settings?.domain?.dnsRecords?.map((record, index) => (
                        <FlexContainer direction="column" key={index}>
                            <FlexContainer direction="row" padding="10px">
                                <FlexContainer
                                    width="6rem"
                                    alignItems="center"
                                    maxHeight="55px"
                                    justifyContent="center"
                                >
                                    <TextLabel marginBottom="0px">{`${record?.Type} ${index + 1}`}</TextLabel>
                                </FlexContainer>
                                <FlexContainer
                                    direction="row"
                                    width="40%"
                                    border="1px solid #D8DEEC"
                                    borderRadius="10px"
                                    padding="10px"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    maxHeight="55px"
                                    marginRight="10px"
                                    gap="20px"
                                >
                                    <TextLabel
                                        fontSize="15px"
                                        marginBottom="0px"
                                        style={{
                                            wordBreak: "break-all",
                                            overflowWrap: "break-word",
                                            whiteSpace: "normal",
                                        }}
                                    >
                                        {record?.Name}
                                    </TextLabel>
                                    <FlexContainer
                                        direction="row"
                                        alignItems="center"
                                        gap="5px"
                                        tDirection="row"
                                        onClick={() => copyValue(record?.Name, index, true)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <img src={Copy} width="20px" height="20px" />
                                        <TextLabel fontSize="15px" marginBottom="0px" color="#016CFF" style={{ width: "3rem" }}>
                                            { lastRecordIndexCopied === index && lastCopyWasHost ? "Copied" : "Copy" }
                                        </TextLabel>
                                    </FlexContainer>
                                </FlexContainer>
                                <FlexContainer
                                    direction="row"
                                    width="60%"
                                    border="1px solid #D8DEEC"
                                    borderRadius="10px"
                                    padding="10px"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    maxHeight="55px"
                                    marginLeft="10px"
                                    marginRight="20px"
                                    gap="20px"
                                >
                                    <TextLabel
                                        fontSize="15px"
                                        marginBottom="0px"
                                        style={{
                                            display: "-webkit-box",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            wordBreak: "break-word",
                                            overflowWrap: "break-word",
                                            whiteSpace: "normal",
                                            width: "100%",
                                        }}
                                    >
                                        {record?.Value}
                                    </TextLabel>
                                    <FlexContainer
                                        direction="row"
                                        alignItems="center"
                                        gap="5px"
                                        tDirection="row"
                                        onClick={() => copyValue(record?.Value, index, false)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <img src={Copy} width="20px" height="20px" />
                                        <TextLabel fontSize="15px" marginBottom="0px" color="#016CFF" style={{ width: "3rem" }}>
                                            { lastRecordIndexCopied === index && !lastCopyWasHost ? "Copied" : "Copy" }
                                        </TextLabel>
                                    </FlexContainer>
                                </FlexContainer>
                            </FlexContainer>
                            { record?.Note &&
                                <FlexContainer direction="row" padding="0 10px 10px" width="80%">
                                    <TextLabel style={{ width: "6rem" }}></TextLabel>
                                    <TextLabel color="#612684" marginBottom="0px">{record?.Note || null}</TextLabel>
                                </FlexContainer>
                            }
                        </FlexContainer>
                    ))}
                </FlexContainer>
                <FlexContainer direction="row" justifyContent="space-between" padding="20px" alignItems="center">
                    <FlexContainer padding="15px" borderRadius="10px" color="#F4E2FF" border="1px solid #612684">
                        <TextLabel marginBottom="0px" fontSize="15px" color="#612684">
                            {"*Once you add these records, it takes up to 24 hours for the authentication to complete."}
                        </TextLabel>
                    </FlexContainer>
                </FlexContainer>
            </FlexContainer>
        </StandardModal>
    );
}
